import { render, staticRenderFns } from "./FTextarea.vue?vue&type=template&id=183c593c&"
import script from "./FTextarea.vue?vue&type=script&lang=js&"
export * from "./FTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports